'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var styled = require('styled-components');
var PropTypes = require('prop-types');
var index = require('../core/index.js');
var button = require('./button.js');
var space = require('./space.js');
var useDidUpdate = require('../hooks/useDidUpdate.js');
var checkbox = require('./checkbox.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  font-style: normal;\n  font-weight: normal;\n  font-size: 13px;\n  line-height: 16px;\n  height: 42px;\n  text-transform: unset;\n  border: 1px solid;\n  display: flex;\n  color: #2b1150;\n  transition: all 0.2s ease-in-out;\n  ", "\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: ", ";\n  width: max-content;\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Wrapper = styled__default['default'].div(_templateObject(), function (props) {
  return props.renderType === 'checkbox' ? 'flex-start' : 'center';
}, index.styleEngine);
var StyledButton = styled__default['default'](button['default'])(_templateObject2(), function (props) {
  return props.parentFlexDirection === 'column' ? "\n      width: 100%;\n      &:not(:last-child) {\n        border-radius: 0px;\n        border-bottom: none;\n      }\n      &:first-child {\n        border-top-right-radius: 3px;\n        border-top-left-radius: 3px;\n        border-bottom-right-radius: 0px;\n        border-bottom-left-radius: 0px;\n      }\n      &:last-child {\n        border-top-right-radius: 0px;\n        border-top-left-radius: 0px;\n        border-bottom-right-radius: 3px;\n        border-bottom-left-radius: 3px;\n      }\n      " : "\n    &:not(:last-child) {\n      border-radius: 0px;\n      border-right: none;\n    }\n    &:first-child {\n      border-top-right-radius: 0px;\n      border-bottom-right-radius: 0px;\n      border-top-left-radius: 3px;\n      border-bottom-left-radius: 3px;\n    }\n    &:last-child {\n      border-top-left-radius: 0px;\n      border-bottom-left-radius: 0px;\n      border-top-right-radius: 3px;\n      border-bottom-right-radius: 3px;\n    }\n    ";
}, function (props) {
  return index.styleEngine({
    bgColor: props.active ? '#B8A3D7' : 'white',
    borderColor: props.active ? '#B8A3D7' : '#e5e5e5',
    padding: '8px 24px',
    color: props.active ? '#2B1150' : '#555555'
  });
});

var getChildren = function getChildren(children) {
  var _children$type, _children$props;

  return ((_children$type = children.type) === null || _children$type === void 0 ? void 0 : _children$type.toString()) === 'Symbol(react.fragment)' ? (_children$props = children.props) === null || _children$props === void 0 ? void 0 : _children$props.children : children;
};

var GroupButton = function GroupButton(_ref) {
  var propActive = _ref.active,
      activeStyle = _ref.activeStyle,
      onChange = _ref.onChange,
      propChildren = _ref.children,
      disabled = _ref.disabled,
      multiple = _ref.multiple,
      renderType = _ref.renderType,
      flexDirection = _ref.flexDirection,
      restProps = _objectWithoutProperties(_ref, ["active", "activeStyle", "onChange", "children", "disabled", "multiple", "renderType", "flexDirection"]);

  var _useState = React.useState(propActive || (multiple ? [] : undefined)),
      _useState2 = _slicedToArray(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  var children = getChildren(propChildren);
  useDidUpdate['default'](function () {
    setActive(propActive || (multiple ? [] : undefined));
  }, [propActive]);
  useDidUpdate['default'](function () {
    onChange && onChange(active);
  }, [active]);

  var update = function update(key) {
    if (multiple) {
      if (key === 'all') {
        if (active.includes('all')) {
          setActive([]);
        } else {
          setActive(['all']);
        }
      } else {
        var newActive = _toConsumableArray(active);

        if (newActive.includes('all')) {
          var index = newActive.indexOf('all');
          newActive = [].concat(_toConsumableArray(newActive.slice(0, index)), _toConsumableArray(newActive.slice(index + 1)));
        }

        if (newActive.includes(key)) {
          var _index = newActive.indexOf(key);

          setActive([].concat(_toConsumableArray(newActive.slice(0, _index)), _toConsumableArray(newActive.slice(_index + 1))));
        } else {
          setActive([].concat(_toConsumableArray(newActive), [key]));
        }
      }
    } else {
      setActive(key);
    }
  };

  return /*#__PURE__*/React__default['default'].createElement(Wrapper, _extends({
    flexDirection: flexDirection,
    renderType: renderType
  }, restProps), React__default['default'].Children.map(children, function (child, index) {
    var _child$props = child.props,
        innerChildren = _child$props.children,
        innerDisabled = _child$props.disabled,
        _onClick = _child$props.onClick,
        restProps = _objectWithoutProperties(_child$props, ["children", "disabled", "onClick"]),
        key = child.key;

    var _key = key || index;

    var isActive = multiple ? active.includes(_key) : active === _key;
    var activeProps = isActive ? activeStyle : {};

    if (renderType === 'checkbox') {
      return /*#__PURE__*/React__default['default'].createElement(space['default'], _extends({
        onClick: function onClick() {
          update(_key);
          _onClick && _onClick();
        }
      }, restProps), /*#__PURE__*/React__default['default'].createElement(checkbox['default'], {
        disabled: typeof disabled !== 'undefined' ? disabled : innerDisabled,
        checked: isActive,
        label: innerChildren
      }));
    }

    return /*#__PURE__*/React__default['default'].createElement(StyledButton, _extends({}, restProps, {
      parentFlexDirection: flexDirection,
      index: index,
      length: children.length,
      disabled: typeof disabled !== 'undefined' ? disabled : innerDisabled,
      onClick: function onClick() {
        update(_key);
        _onClick && _onClick();
      },
      active: isActive
    }, activeProps), innerChildren);
  }));
};

GroupButton.propTypes = {
  active: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].array]).isRequired,
  activeStyle: PropTypes__default['default'].object,
  onChange: PropTypes__default['default'].func,
  disabled: PropTypes__default['default'].bool,
  multiple: PropTypes__default['default'].bool,
  flexDirection: PropTypes__default['default'].string,
  renderType: PropTypes__default['default'].string,
  children: PropTypes__default['default'].oneOfType([PropTypes__default['default'].element, PropTypes__default['default'].arrayOf(PropTypes__default['default'].element)])
};

exports.default = GroupButton;
